import React from 'react';

import { LayoutProvider } from '../../../common/contexts';
import { useResponsiveLayout } from '../../../common/hooks';
import { DesktopLayout, MobileLayout } from '../../../common/layouts';
import { useRouteMapper } from '../../navigation/route-mapper';

const AuthenticatedApp = () => {
  const currentComponent = useRouteMapper();
  const { isMobile } = useResponsiveLayout();

  const LayoutComponent = isMobile ? MobileLayout : DesktopLayout;

  return (
    <LayoutProvider>
      <LayoutComponent>{currentComponent}</LayoutComponent>
    </LayoutProvider>
  );
};

export default AuthenticatedApp;
